export type UserRole = "tenant" | "landlord" | "guarantor";

export type AccountType = "tenant" | "landlord";

export type AppType = "skor" | "macc";

export type AuthMode = "login" | "signup";

export type AuthScreen =
  | "email"
  | "verifyOtp"
  | "signup"
  | "login"
  | "forgotPassword"
  | "verifyOtpForgot"
  | "landlordBasicInfo"
  | "landlordOnboarding";

const MACC_HOSTNAME = "alquilatuhogar.skortorent.com";

const ROLE_BY_PATH: Record<string, UserRole> = {
  "/tenant/auth": "tenant",
  "/landlord/auth": "landlord",
  "/guarantor/auth": "guarantor",
};

export function getUserRoleFromPath(pathname: string): UserRole {
  return ROLE_BY_PATH[pathname] ?? "tenant";
}

export function getAppType(): AppType {
  return window.location.hostname === MACC_HOSTNAME ? "macc" : "skor";
}

export interface UserLoginForm {
  _id: string | null;
  email: string;
  password: string;
  confirmPassword: string;
  type: AccountType;
  checkedTenant: boolean;
  checkedLandlord: boolean;
  user_type: AppType;
  checked: boolean;
  qrCode_signup: boolean;
  analysisCompleted: boolean;
  requestProfileLink: string | null;
  fname: string;
  fname_companyName: string;
  lname: string;
  identity_number: string;
  post_code: string;
  dob: string;
  employment_status: string;
  employment_category: string;
  current_annual_income: string;
  protected_housing: boolean;
  phone_number: string;
  phone: string;
  currency: string;
  skip_steps?: string[];
  consents?: unknown;
  company_legal_name: string;
  company_cif: string;
  company_type: string;
  company_cnae: string;
  company_representative_position: string;
}

export function createInitialUserLogin(
  type: AccountType = "tenant"
): UserLoginForm {
  return {
    _id: null,
    email: "",
    password: "",
    confirmPassword: "",
    type,
    checkedTenant: type === "tenant",
    checkedLandlord: type === "landlord",
    user_type: getAppType(),
    checked: false,
    qrCode_signup: false,
    analysisCompleted: true,
    requestProfileLink: null,
    fname: "",
    fname_companyName: "",
    lname: "",
    identity_number: "",
    post_code: "",
    dob: "",
    employment_status: "",
    employment_category: "",
    current_annual_income: "",
    protected_housing: false,
    phone_number: "",
    phone: "",
    currency: "EUR",
    company_legal_name: "",
    company_cif: "",
    company_type: "",
    company_cnae: "",
    company_representative_position: "",
  };
}
